import { Injectable } from '@angular/core';
import { UTCDateRange } from '@epicuro-next/ataraxia/models';
import { FiltersFieldIds } from '@epicuro-next/models/order-book';
import { makeIntervalISODate } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { filter, map, withLatestFrom } from 'rxjs/operators';

import * as filtersActions from '../actions/filters.actions';
import {
  selectRegularActiveOrderBookFilters,
  selectSelectedPlacedPeriod,
} from '../selectors/filters.selectors';

@Injectable()
export class PlacedPeriodFilterEffects {
  constructor(private actions$: Actions, private store: Store) {}
  public onPlacedPeriodSelect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(filtersActions.changePlacedPeriod),
      map(({ range }) => range),
      filter((v): v is UTCDateRange => !!v),
      map(({ from, to }) => makeIntervalISODate(from, to)),
      map((value) => ({ fieldId: FiltersFieldIds.PlacedPeriod, value })),
      withLatestFrom(
        this.store.pipe(select(selectRegularActiveOrderBookFilters)),
        (placedPeriodFilter, activeFilters) => [
          ...activeFilters,
          placedPeriodFilter,
        ],
      ),
      map((filters) =>
        filtersActions.setActiveFilters({
          filters,
        }),
      ),
    ),
  );

  public onPlacedPeriodCancel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(filtersActions.changePlacedPeriod),
      withLatestFrom(this.store.pipe(select(selectSelectedPlacedPeriod))),
      filter(([{ range }, placedFilter]) => !range && Boolean(placedFilter)),
      withLatestFrom(
        this.store.pipe(select(selectRegularActiveOrderBookFilters)),
      ),
      map(([_, filters]) => filtersActions.setActiveFilters({ filters })),
    ),
  );
}
